module.exports = "/_next/static/images/Daniel_Armas-ad564574470323621909df11e718c2dc.webp";